/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { handleShowReviewModal, dismissAlert }
) => (
  <>
    {row.hasOwnProperty("exception") && row.exception != null && (
      <OverlayTrigger
        overlay={<Tooltip id="open-alert-review">Review</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary"
          onClick={() =>
            handleShowReviewModal(row)
          }
        >
          <i className="flaticon-eye"></i>
        </a>
      </OverlayTrigger>
    )}
    <> </>
    <OverlayTrigger overlay={<Tooltip id="open-alert-review">Mark as reviewed</Tooltip>}>
      <a
        className="btn btn-icon btn-light btn-hover-success"
        onClick={() => dismissAlert(row.id)}
      >
        <i className="flaticon2-accept"></i>
      </a>
    </OverlayTrigger>
  </>
);
